/**
=========================================================
* Soft UI Dashboard React - v3.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Soft UI Dashboard React base styles
import colors from "assets/theme/base/colors";
import boxShadows from "assets/theme/base/boxShadows";
import borders from "assets/theme/base/borders";

const { white } = colors;
const { xxl } = boxShadows;
const { borderRadius } = borders;

const tableContainer = {
  styleOverrides: {
    root: {
      backgroundColor: white.main,
      boxShadow: xxl,
      borderRadius: borderRadius.lg,
      // Clip the corners so striped rows and the header band cannot bleed
      // past the rounded edge.
      overflow: "hidden",

      /**
       * Wide tables (orders, containers) scroll inside their own card instead
       * of pushing the whole page sideways. The custom scrollbar keeps that
       * from looking like a browser default dropped into the design.
       */
      overflowX: "auto",
      "&::-webkit-scrollbar": { height: 8, width: 8 },
      "&::-webkit-scrollbar-track": { background: "transparent" },
      "&::-webkit-scrollbar-thumb": {
        background: "rgba(11, 27, 58, 0.18)",
        borderRadius: 8,
      },
      "&::-webkit-scrollbar-thumb:hover": {
        background: "rgba(11, 27, 58, 0.32)",
      },
    },
  },
};

export default tableContainer;
